import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/docs`;

export const VIDEO_SHOOTING_TIPS_TIP1 = `${ROOT}/tip1.png?imageMogr2/thumbnail/!60p`;
export const VIDEO_SHOOTING_TIPS_TIP2 = `${ROOT}/tip2.png?imageMogr2/thumbnail/!60p`;
export const VIDEO_SHOOTING_TIPS_TIP3 = `${ROOT}/tip3.png?imageMogr2/thumbnail/!60p`;
